/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Isir_EmptyInputs */

const cs_property_registry_isir_empty = /** @type {(inputs: Property_Registry_Isir_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro zadaná kritéria se nenašla žádná insolvenční řízení.`)
};

const en_property_registry_isir_empty = /** @type {(inputs: Property_Registry_Isir_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No insolvency cases found for these criteria.`)
};

/**
* | output |
* | --- |
* | "No insolvency cases found for these criteria." |
*
* @param {Property_Registry_Isir_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_isir_empty = /** @type {((inputs?: Property_Registry_Isir_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Isir_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_isir_empty(inputs)
	return cs_property_registry_isir_empty(inputs)
});